import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Confirm,
  Form,
  Grid,
  Icon,
  Image,
  Input,
  TextArea,
  Modal,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { uid } from "uid";
import { addAdvocate } from "../../store/actions/athleteActions";
import { BsFillPatchCheckFill } from "react-icons/bs";
import {
  phoneRegex,
  imageRegex,
  igregex,
  emailRegex,
  passwordRegex,
  fbregex,
  twitterRegex,
  linkedinRegex,
} from "../../utils/regex";
const AddAdvocate = (props) => {
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [error, setError] = useState(false);
  const [warning, setWarning] = useState(false);
  const [name, setName] = useState(null);
  const [title, setTitle] = useState(null);
  const [facebook, setFacebook] = useState(null);
  const [instagram, setInstagram] = useState(null);
  const [twitter, setTwitter] = useState(null);
  const [linkedin, setLinkedin] = useState(null);
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [password2, setPassword2] = useState(null);
  const [showPass, setShowPass] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [info, setInfo] = useState(null);
  const dispatch = useDispatch();
  const handleSubmit = () => {
    if (thumbnail && name && title && info && email && password === password2) {
      const exist = props.emails.map(
        (element) => email === element.toLowerCase()
      );
      if (exist.includes(true)) {
        setError("You can't use this email");
      } else {
        const data = {
          id: uid(8),
          name,
          title,
          email,
          thumbnail,
          info,
          password,
          order: props.lastOrder ? props.lastOrder + 1 : 1,
        };
        if (facebook) {
          data.facebook = facebook;
        }
        if (instagram) {
          data.instagram = instagram;
        }
        if (twitter) {
          data.twitter = twitter;
        }
        if (linkedin) {
          data.linkedin = linkedin;
        }
        if (phone) {
          data.phone = phone;
        }
        if (email) {
          data.email = email;
        }
        if (!error) {
          dispatch(addAdvocate(data));
          setThumbnail(false);
          setThumbnailUrl(false);
          setError(false);
          setWarning(false);
          setName(false);
          setTitle(false);
          setFacebook(false);
          setInstagram(false);
          setTwitter(false);
          setLinkedin(false);
          setPhone(false);
          setEmail(false);
          setShowPass(false);
          setShowPass2(false);
          setPassword(false);
          setPassword2(false);
          setInfo(false);
        }
      }
    } else {
      if (password && password2 && password !== password2) {
        setWarning("Password Does Not Match");
      } else if (
        !thumbnail ||
        !name ||
        !title ||
        !info ||
        !email ||
        !password ||
        !password2
      );
      setWarning("Fields with *  Are Required");
    }
  };
  const handleThumbnail = (e) => {
    if (imageRegex.test(e.target.files[0].name)) {
      setThumbnailUrl(URL.createObjectURL(e.target.files[0]));
      setThumbnail(e.target.files[0]);
      setError(null);
    } else {
      setError("It should be image");
    }
  };

  const handleShowPass = () => setShowPass(!showPass);
  const handleShowPass2 = () => setShowPass2(!showPass2);
  const handleTitleChange = (data) => {
    setTitle(data);
  };
  const handleNameChange = (data) => {
    setName(data);
  };
  const handleInfoChange = (data) => {
    setInfo(data);
  };
  const handleFacebookChange = (data) => {
    if (fbregex.test(data)) {
      setFacebook(data);
      setError(false);
    } else {
      setError("It should be Facebook profile");
    }
  };
  const handleInstagramChange = (data) => {
    if (igregex.test(data)) {
      setInstagram(data);
      setError(false);
    } else {
      setError("It should be Instagram profile");
    }
  };
  const handleTwitterChange = (data) => {
    if (twitterRegex.test(data)) {
      setTwitter(data);
      setError(false);
    } else {
      setError("It should be Twitter profile");
    }
  };
  const handleLinkedinChange = (data) => {
    if (linkedinRegex.test(data)) {
      setLinkedin(data);
      setError(false);
    } else {
      setError("It should be Linkedin profile");
    }
  };
  const handlePhoneChange = (data) => {
    if (phoneRegex.test(data)) {
      setPhone(data);
      setError(false);
    } else {
      setError("It should be cell number without any characters");
    }
  };
  const handleEmailChange = (data) => {
    if (emailRegex.test(data)) {
      setEmail(data.toLowerCase());
      setError(false);
    } else {
      setError("It should be email ");
    }
  };
  const handlePasswordChange = (data) => {
    if (passwordRegex.test(data)) {
      setPassword(data);
      setError(false);
    } else {
      setError(
        "It Should Be 8 to 30 Characters Long Contains 1 Upper Case 1 Lower Case 1 Number 1 Special Character "
      );
    }
  };
  const handlePassword2Change = (data) => {
    if (data === password) {
      setPassword2(data);
      setError(false);
    } else {
      setError("Password does not match");
    }
  };
  const handleClose = () => {
    props.onClose();
    setThumbnail(false);
    setError(false);
    setWarning(false);
    setName(false);
    setTitle(false);
    setFacebook(false);
    setInstagram(false);
    setTwitter(false);
    setLinkedin(false);
    setPhone(false);
    setEmail(false);
    setInfo(false);
    setThumbnailUrl(false);
    setShowPass(false);
    setShowPass2(false);
    setPassword(false);
    setPassword2(false);
  };
  props.progress === 100 &&
    setTimeout(() => {
      handleClose();
    }, 2000);

  return (
    <Modal onClose={props.onClose} open={props.open}>
      <Modal.Content scrolling>
        <div className="AdminTopButtonsProgressContainer">
          <div className="AdminTopButtonsContainer d-custom">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={handleClose}
            />
            <div className="d-CustomInnderdiv">
              {props.progress === 100 && (
                <span className="successPlayerToWatch">
                  Added <BsFillPatchCheckFill size={16} />
                </span>
              )}
              {!error && !props.saving && (
                <Button
                  floated="right"
                  positive
                  name="saveButton"
                  content="Save"
                  labelPosition="right"
                  icon="checkmark"
                  onClick={handleSubmit}
                />
              )}
              {error && (
                <Button
                  floated="right"
                  disabled
                  name="saveButton"
                  content="Save"
                  labelPosition="right"
                  icon="checkmark"
                  onClick={handleSubmit}
                />
              )}
              {props.saving && (
                <Button
                  floated="right"
                  loading
                  name="saveButton"
                  content="Save"
                  labelPosition="right"
                  icon="checkmark"
                />
              )}
            </div>
          </div>
        </div>
        <div className="head-data">
          <h3 className="cu-center">Add Advocate</h3>
          {error && <p style={{ color: "#800000" }}>{error}</p>}
          {warning && <p style={{ color: "#FF6600" }}>{warning}</p>}
        </div>
        <ul className="full mix-both">
          <li>
            <div className="full-skills full">
              <div className="one-skill">
                <div className="thumbnail-advocate-image">
                  {thumbnailUrl && <Image src={thumbnailUrl} />}
                  {!thumbnailUrl && (
                    <Image
                      src={
                        "https://via.placeholder.com/200x200.png/e6e6e6/000000?Text=200x200"
                      }
                    />
                  )}
                  <label htmlFor="thumbnail">
                    <Icon name="upload" />
                  </label>
                  <Input
                    type="file"
                    id="thumbnail"
                    style={{ display: "none" }}
                    placeholder="Select image"
                    onChange={handleThumbnail}
                  />
                </div>
              </div>
              <div className="two-skill">
                <Grid divided="vertically">
                  <Grid.Row stackable="true" columns={2}>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Name *</label>
                        <Input
                          placeholder="Name"
                          onChange={(e) => handleNameChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Title *</label>
                        <Input
                          placeholder="Title"
                          onChange={(e) => handleTitleChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <Form.Field>
                        <label>About Us *</label>
                        <TextArea
                          className="cu-textarea"
                          placeholder="Tell us more"
                          onChange={(e) => handleInfoChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Facebook</label>
                        <Input
                          placeholder="Facebook URL"
                          onChange={(e) => handleFacebookChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Twitter</label>
                        <Input
                          placeholder="Twitter URL"
                          onChange={(e) => handleTwitterChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Instagram</label>
                        <Input
                          placeholder="Instagram URL"
                          onChange={(e) =>
                            handleInstagramChange(e.target.value)
                          }
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Linkedin</label>
                        <Input
                          placeholder="Linkedin URL"
                          onChange={(e) => handleLinkedinChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Cell</label>
                        <Input
                          placeholder="Contact No"
                          onChange={(e) => handlePhoneChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Email *</label>
                        <Input
                          placeholder="Email"
                          onChange={(e) => handleEmailChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field className="cu-input-group">
                        <label>Password *</label>
                        <Input
                          placeholder="Password"
                          type={showPass ? "text" : "password"}
                          onChange={(e) => handlePasswordChange(e.target.value)}
                        />
                        <Icon
                          className="password-icon"
                          name={`eye ${showPass ? "slash" : ""}`}
                          onClick={handleShowPass}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field className="cu-input-group">
                        <label>Confirm Password *</label>
                        <Input
                          placeholder="Confirm Password"
                          type={showPass2 ? "text" : "password"}
                          onChange={(e) =>
                            handlePassword2Change(e.target.value)
                          }
                        />
                        <Icon
                          className="password-icon"
                          name={`eye ${showPass2 ? "slash" : ""}`}
                          onClick={handleShowPass2}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          </li>
        </ul>
        <Confirm
          // open={this.state.confirmOpen}
          content="You have unsaved changes.  Are you sure you want to exit?"
          // onCancel={this.confirmCloseCancel}
          // onConfirm={this.confirmClose}
        />
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    sucess: state.athlete.advocateAdded,
    saving: state.athlete.advocateAdding,
    progress: state.athlete.advocateAddProgress,
    file: state.athlete.advocateAddProgressType,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "advocates",
    },
  ])
)(AddAdvocate);
